import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "../configs/firebase";

export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();

    if (permission !== "granted") {
      console.log("Permission denied");
      return null;
    }

    const token = await getToken(messaging, {
      vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY,
    });

    console.log("FCM TOKEN:", token);

    return token;

  } catch (error) {
    console.log("FCM Error:", error);
  }
};

export const listenForMessages = () => {
  onMessage(messaging, (payload) => {
    console.log("Message received:", payload);

    alert(
      `${payload.notification.title}\n${payload.notification.body}`
    );
  });
};